/**
 * Utility functions for handling image URLs
 */

declare const process: {
    env: {
        REACT_APP_S3_BASE_URL: string;
    };
};

/**
 * Converts a relative image URL to an absolute URL or returns base64 data as is
 * @param url The image URL or base64 data to process
 * @returns The processed URL or base64 data
 */
export const getAbsoluteImageUrl = (url: string): string => {
    if (!url) return "";

    // If it's base64 data, return as is
    if (url.startsWith("data:image/")) {
        return url;
    }

    // If it's already an absolute URL, return as is
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }

    // If it's an S3 URL (doesn't start with http/https or /), prepend S3 base URL
    if (!url.startsWith("/")) {
        return `${process.env.REACT_APP_S3_BASE_URL}/${url}`;
    }

    // If it's a local URL (starts with /), prepend origin
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return `${origin}${url}`;
};
